<script>
    import { createEventDispatcher } from 'svelte';

    export let showAck;
    export let message;
    export let showCancel = false;
    export let continueButtonText = 'Continue';

    let dispatch = createEventDispatcher();

    function handleConfirm() {
        dispatch('confirm');
    }

    function handleCancel() {
        dispatch('cancel');
    }
</script>

<div class="modal" role="dialog" aria-modal="true">
    {@html message}
    <div class="buttons" >
        <button type="button" class="login-buttons" on:click={()=>{
            showAck=false;
            handleConfirm();
            }
        }>
            {continueButtonText}
        </button>
        {#if (showCancel)}
            <button type="button" class="login-buttons" on:click={()=>{showAck=false;handleCancel()}}>
                Cancel
            </button>
        {/if}
    </div>
</div>

<style>
    .modal {
		position: fixed;
		left: 50%;
		top: 50%;
		width: calc(100vw - 4em);
		max-width: 60em;
		max-height: calc(100vh - 2em);
		overflow-x: hidden;
		overflow-y: auto;
		transform: translate(-50%,-50%);
		padding: 1em;
		border-radius: 0.2em;
		background: ghostwhite;
		color: #333;
		border: 2px solid black;
		box-shadow: 2px 2px 4px #5157d4, inset 2px 2px 4px #9c0ccf;
		border-radius: 10px;
		font-size: 0.9rem;
		font-family: Noto Sans Regular;
		z-index:1000;
	}
    .login-buttons{
		height: 30px;
		max-height: 30px;
		flex-grow: 0;
		font-size: 0.9rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		padding: 10px 15px;
		border-style: solid;
		border-width: 3px;
		border-image-source: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		border-image-slice: 1;
		border-radius: 4px;
		background-image: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		color: ghostwhite;
		cursor: pointer;
		box-sizing: border-box;
	}
    .buttons{
        display:flex;
        padding:2px;
        gap: 2%;
        justify-content: center;
        align-items: center;
    }
</style>